export default __webpack_public_path__ + "static/media/priority_icon1.b7fcd585.png";